import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWallet = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M0,0h24v24h-24Z" }),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M3.039,7.915h15.961c1.105,0 2,0.895 2,2v9.085c0,1.1 -0.9,2 -2,2h-14c-1.105,0 -2,-0.895 -2,-2v-10.709c0,-0.832 0.515,-1.577 1.294,-1.871l10.353,-3.909c0.654,-0.247 1.353,0.236 1.353,0.935v4.468"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M15.999,14.125c-0.207,0.001 -0.374,0.169 -0.374,0.376c0,0.207 0.168,0.375 0.375,0.374c0.207,0 0.375,-0.168 0.375,-0.375c0,-0.207 -0.168,-0.375 -0.376,-0.375"
			})
		]
	})
});
export default SvgWallet;
